import { memo, PropsWithChildren } from 'react';
import { Helmet } from "react-helmet-async";
import type { ScreenProps } from './types';
import { Authorized } from '../Auth';

const Screen = ({
    title,
    children,
    fallback,
    roles = [],
    ...helmetProps
}: PropsWithChildren<ScreenProps>) => (
    <>
        <Helmet
            {...helmetProps}
            title={`${title} | Macropay | Tech and advisory for financial institutions`}
        />
        <Authorized
            roles={roles}
            fallback={fallback}
        >
            {children}
        </Authorized>
    </>
);

export default memo(Screen);
